<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        독감예방접종신청
      </v-col>
    </v-row>

    <div class="apply-list px-6 overflow-y-auto">
      <v-text-field
        label="대상자명"
        v-model="GET_TGT_NAME"
        readonly
      ></v-text-field>
      <v-text-field
        label="실접종비"
        v-model="realAmnt"
        @input="inputNumber($event)"
        oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
      ></v-text-field>
      <v-text-field 
        label="신청금액" 
        v-model="applAmnt"
        @input="inputNumber($event)"
        oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
      ></v-text-field>
      <div class="borderLine-wrap" v-show="fileShow">
        <span class="borderLine-title">첨부파일</span>
        <v-btn
          elevation="0"
          text
          fab
          width="24"
          height="24"
          class="ml-auto"
          @click="fileFlag = !fileFlag"
        >
          <v-icon size="24" color="#9ca3ab">mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
    <bgf-attach-file-add ref="bgfAttachFile" />
    <v-bottom-navigation fixed scroll-threshold="500" height="96">
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="applovalPage"
          >
            <span class="white--text">다음</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
    <bgf-attach-file-bottom-select
      :flag="fileFlag"
      @selectItem="changeFile"
    ></bgf-attach-file-bottom-select>
  </div>
</template>

<script>
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg
import { mapGetters } from 'vuex';
import {
  getVaccinationPayBaseAmt,
  //  vaccinationSave,
} from '@/api/workStatus';
//import { applovalCommonSave } from '@/api/approvalCommon';

import dayjs from 'dayjs';
import routerNames from '@/const/routerConstants';
import BgfAttachFileAdd from '@/components/application/form/BgfAttachFileAdd.vue';
import BgfAttachFileBottomSelect from '@/components/application/form/BgfAttachFileBottomSelect.vue';

export default {
  data: () => ({
    applLevelSheet: false, // 대상자명 화면플래그
    tgtName: '본인',
    selecttitle: '대상자명',
    realAmnt: '',
    applAmnt: '',
    codeList: [],
    famRshipCd: 'SE', // 기본값 본인
    mgrUserListProps: [],
    fileFlag: false,
    fileShow: true,
    baseAmnt: '',
  }),

  computed: {
    ...mapGetters('ELA', [
      'GET_APPL_SEQ_EXIST',
      'GET_REFER_USER_LIST',
      'GET_MGR_USER_LIST',
      'GET_UI_INFO',
      'GET_ELA_APPL_PARAM',
      'GET_APPL_USER_LIST',
      'GET_MGR_USER_LIST',
      'GET_VACCINATION_PARAM',
    ]),
    ...mapGetters([
      'GET_USER_DATA',
      'GET_FAMRSHIPCD_CD',
      'GET_TGT_NAME',
      'GET_FILE_SEQ',
      'GET_PARAMS',
    ]),
  },

  methods: {
    changeFile(levelObj) {
      if (levelObj === 'C') {
        this.$refs.bgfAttachFile.callCamera();
      } else if (levelObj === 'G') {
        this.$refs.bgfAttachFile.callGallery();
      }

      this.fileFlag = false;
    },
    inputNumber(inputValue) {
      this.result = inputValue;
      this.formatInput();
    },

    applovalPage() {
      if (this.GET_TGT_NAME === null) {
        alert('대상자명을 확인해 주세요');
        return;
      }

      if (this.realAmnt.trim() === '') {
        alert('실접종비를 입력해 주세요');
        return;
      }

      if (
        Number(this.applAmnt.replaceAll(',', '').replaceAll('원', '')) >
        Number(this.realAmnt.replaceAll(',', '').replaceAll('원', ''))
      ) {
        alert('신청금액은 실접종비보다 작거나 같아야합니다');
        return;
      }

      if (
        Number(this.applAmnt.replaceAll(',', '').replaceAll('원', '')) >
        Number(this.baseAmnt.replaceAll(',', '').replaceAll('원', ''))
      ) {
        alert('신청금액이 한도금액('+ this.baseAmnt +')을 초과 수 없습니다.');
        return;
      }



      if (this.GET_UI_INFO.fileEssentialYn === 'Y') {
        if(this.GET_FILE_SEQ === '' || this.GET_FILE_SEQ === 0) {
          alert('파일 첨부는 필수 입니다');
          return;
        }
      }

      const params = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        searchApplCd: this.GET_ELA_APPL_PARAM.searchApplCd,
        searchApplSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        searchApplSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
        searchApplYmd: dayjs().format('YYYYMMDD'),
        searchApplName: this.GET_USER_DATA.ssnName,
        authPg: 'A', // A신청, R결제
        pathSeq: '',
        applStatusCd: '31', //수신처리중
        fileSeq: this.GET_FILE_SEQ,
        procExecYn: this.GET_UI_INFO.procExecYn,
        etc01: this.GET_UI_INFO.etc01,
        etc02: this.GET_UI_INFO.etc02,
        etc03: this.GET_UI_INFO.etc03,
        etc04: this.GET_UI_INFO.etc04,
        etc05: this.GET_UI_INFO.etc05,
        realAmnt: Number(
          this.realAmnt.replaceAll(',', '').replaceAll('원', ''),
        ),
        applAmnt: Number(
          this.applAmnt.replaceAll(',', '').replaceAll('원', ''),
        ),
        tgtName: this.GET_TGT_NAME,
        applTypeCd: '10', //본인신청
        famRshipCd: this.GET_FAMRSHIPCD_CD,
      };

      this.$store.commit('SET_AUTHPG', 'A');
      this.$store.commit('SET_PARAMS', params);
      this.$store.dispatch('ELA/SET_VACCINATION_PARAMS', params);
      this.$router.push(routerNames.ApprovalLine);
    },

    formatInput() {
      // 입력된 값을 숫자로 파싱하고 천 단위 콤마 추가
      const parsedAmount = parseFloat(this.realAmnt.replace(/,/g, '')) || 0;
      const parsedAmount2 = parseFloat(this.applAmnt.replace(/,/g, '')) || 0;
      this.realAmnt = parsedAmount.toLocaleString() + '원';
      this.applAmnt = parsedAmount2.toLocaleString() + '원';
    },
  },

  async mounted() {
    let params = {
      year: dayjs().year(),
      famRshipCd: this.GET_FAMRSHIPCD_CD, // 디폴트 SE(본인)
    };

    const response = await getVaccinationPayBaseAmt(params);
    this.baseAmnt =
      Number(response.data.data.suptAmntLimit).toLocaleString() + '원';

    this.realAmnt =
      this.GET_PARAMS.realAmnt === undefined
        ? ''
        : Number(this.GET_PARAMS.realAmnt).toLocaleString() + '원';

    if (this.GET_UI_INFO.fileYn === 'N') {
      this.fileShow = false;
    }
  },

  components: {
    IconApprovalDoc,
    BgfAttachFileAdd,
    BgfAttachFileBottomSelect,
  },
};
</script>

<style>
/* _approval.scss 에 넣음 */
/* dialog */
/* .v-dialog:not(.v-bottom-sheet) {
  background-color: white;
  height: inherit;
} */
</style>
